/* eslint-disable react/jsx-key */
import React from "react";
import styled from "styled-components";
import computerImage from "@assets/images/auth/computer.png";
import notebookImage from "@assets/images/auth/notebook.png";
import tabletImage from "@assets/images/auth/tablet.png";

const Notebook = styled.img`
	position: absolute;
	transform: rotate(-10deg);
	width: 88px;
	top: 20px;
	right: 0;
`;
const Computer = styled.img`
	position: absolute;
	width: 120px;
	top: 20px;
	right: -10px;
`;
const Tablet = styled.img`
	position: absolute;
	width: 120px;
	top: 20px;
	right: -10px;
`;

const NotebookBig = styled.img`
	position: absolute;
	transform: rotate(-10deg);
	width: 140px;
	top: 19px;
	right: -13px;
`;
const ComputerBig = styled.img`
	position: absolute;
	width: 140px;
	top: 19px;
	right: -13px;
`;
const TabletBig = styled.img`
	position: absolute;
	width: 140px;
	top: 19px;
	right: -13px;
`;

export const Illustrations = [
	<Notebook src={notebookImage} />,
	<Computer src={computerImage} />,
	<Tablet src={tabletImage} />,
	<NotebookBig src={notebookImage} />,
	<ComputerBig src={computerImage} />,
	<TabletBig src={tabletImage} />,
];
